import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './plugins/element.js'

// 引入AOS动画库
import AOS from 'aos'
import 'aos/dist/aos.css'

import './assets/fonts/font.css'

Vue.config.productionTip = false
Vue.use(ElementUI)

console.log(window);

new Vue({
  router,
  render: h => h(App),
  mounted() {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
      offset: 100,
      // disable: () => window.innerWidth < 768, // 需要使用keep-alive 添加缓存， 否则跳转到其他页面，再跳转回来的时候， 这个设置就失效了，内容不展示
    })
  }
}).$mount('#app')